import {
  ApiInterface,
  EmptyObject,
  PaginatedQueryParams,
  PaginatedResponse,
} from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { Inventory } from '../../entities/inventory';

export type Interface = ApiInterface<{
  response: PaginatedResponse<Inventory>;
  pathParams: EmptyObject;
  body: EmptyObject;
  claims: { tenantId: string; isAdmin: string };
  queryParams: PaginatedQueryParams & { tenantId?: string };
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-list-inventory',
  method: 'GET',
  basePath: 'inventory',
  path: '/',
  tablePermission: 'read',
  scope: 'RECEPTIONIST',
};
